import axios from "axios";
import { ENV } from "../utils/env.js";

class ClientApi {
  async getClientStatus() {
    try {
      const response = await axios.get(
        `${ENV.REACT_APP_URL}api/server/client/status`,
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${localStorage.getItem('jwt')}`,
          },
        }
      );
      return response;
    } catch (error) {
      console.error("Error getting client status:", error);
      throw error;
    }
  }

  async verifyPublicKey(payload) {
    try {
      const response = await axios.post(
        `${ENV.REACT_APP_URL}api/auth/client/verify`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${localStorage.getItem('jwt')}`,
          },
        }
      );
      return response;
    } catch (error) {
      console.error("Error verifying public key:", error);
      throw error;
    }
  }
}

export const clientApi = new ClientApi();
